import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../shared/logger';

export const GdprComplianceService = (Restangular, $localStorage, LocationService) => {
    const locationsInfoCache = {};

    const checkIfPositionLocationItemIsGdprCompliant = function ({
        location,
        gdprLocations,
        countries,
        country: countryName,
        code: countryCode,
    }) {
        if (location.isGdpr) {
            return true;
        }

        const gdprLocationIds = _.map(gdprLocations, 'id');
        const gdprLocationValues = _.chain(gdprLocations)
            .map('value')
            .flatten()
            .filter(Boolean)
            .value();

        let isGdpr;
        if (gdprLocationIds.includes(location.uid)) {
            isGdpr = true;
        } else if (countryName || countryCode) {
            isGdpr = _.includes(gdprLocationValues, countryName) || _.includes(gdprLocationValues, countryCode);
        } else {
            const { country } = LocationService.extractLocationDataFromLocationText({ text: location?.text, countries });
            const countryEn = LocationService.getEnglishCountryCode({ country, countries });
            isGdpr = _.includes(gdprLocationValues, countryEn);
        }

        return isGdpr;
    };

    const getLocationCountryInfo = function (text) {
        const cachedDataPromise = _.get(locationsInfoCache, text);

        if (cachedDataPromise) {
            return cachedDataPromise;
        }

        const dataPromise = Restangular.all('metadata')
            .all('getLocationCountryInfo')
            .post({ locationName: text })
            .then(({ result }) => result)
            .catch((error) => Logger.error(error));

        _.set(locationsInfoCache, text, dataPromise);

        return dataPromise;
    };

    const checkIfPositionIsGdprCompliant = async function ({ position, gdprLocations, countries }) {
        let isGdpr;

        if (_.has(position, 'desiredCandidateProfile.selected')) {
            const positionLocations = _.chain(position)
                .get('desiredCandidateProfile.selected')
                // @ts-ignore
                .find({ field: 'locations' })
                .get('items')
                .value();

            const positionLocationsInfo = await Promise.allSettled(_.map(
                positionLocations,
                async (l) => {
                    const countryInfo = await getLocationCountryInfo(l.text);

                    return {
                        locationName: l.text,
                        ...countryInfo,
                    };
                },
            ));

            const positionLocationCountries = _.map(positionLocationsInfo, (result) => _.get(result, 'value'));

            isGdpr = !!_.chain(positionLocations)
                .find((location) => {
                    const countryInfo = _.chain(positionLocationCountries)
                        .find({ locationName: location.text })
                        .value();

                    return checkIfPositionLocationItemIsGdprCompliant({
                        location,
                        gdprLocations,
                        countries,
                        ...countryInfo,
                    });
                })
                .value();

            return isGdpr;
        }
    };

    return {
        checkIfPositionIsGdprCompliant,
    };
};

angular
    .module('TALENYA-FE')
    .factory('GdprComplianceService', GdprComplianceService);
